import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Loader2, Users, Activity, TrendingUp, CalendarClock, UserX } from "lucide-react";

function Card({ icon: Icon, label, value, sub }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5">
      <div className="flex items-center justify-between">
        <span className="text-sm text-slate-500">{label}</span>
        <Icon className="h-4 w-4 text-slate-400" />
      </div>
      <div className="mt-2 font-display text-3xl font-bold text-slate-900">{value}</div>
      {sub && <div className="text-xs text-slate-400 mt-1">{sub}</div>}
    </div>
  );
}

export default function Overview() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin-overview"],
    queryFn: async () => (await api.get("/admin/analytics/overview")).data,
  });
  if (isLoading) return <div className="py-20 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;

  return (
    <div className="space-y-8">
      <div>
        <p className="font-mono text-xs uppercase tracking-widest text-slate-400">Admin</p>
        <h1 className="mt-1 font-display text-3xl font-bold text-slate-900">Overview</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        <Card icon={Users} label="Active students" value={data.active_students} />
        <Card icon={Activity} label="Reviews today" value={data.reviews_today} />
        <Card icon={Activity} label="Reviews this week" value={data.reviews_week} />
        <Card icon={TrendingUp} label="Average retention" value={`${data.avg_retention}%`} />
        <Card icon={CalendarClock} label="Studied today" value={data.studied_today} />
        <Card icon={UserX} label="Inactive 7+ days" value={data.inactive_students} />
      </div>

      <div>
        <h2 className="font-display text-lg font-semibold text-slate-900 mb-3">Most-studied courses</h2>
        {data.most_studied_courses.length === 0 ? (
          <div className="rounded-xl border border-slate-200 bg-white p-6 text-center text-slate-500">No review activity yet this week.</div>
        ) : (
          <div className="space-y-2">
            {data.most_studied_courses.map((c) => (
              <div key={c.course} className="flex items-center justify-between rounded-xl border border-slate-200 bg-white px-5 py-3">
                <span className="text-slate-800">{c.course}</span>
                <span className="font-mono text-sm text-slate-500">{c.reviews} reviews</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
